import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PushEventService implements OnDestroy
{
  private messagingLanguageChangedSubscription: Subscription;

  constructor(private http: HttpClient) { }
  
  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  public createPushEvent(data: any): Observable<any>
  {
    return this.http.post('/pushevent', data);
  }

  public pushEventForPatientExists(lastName: string, firstName: string, mpi: string, dateOfBirth: string): Observable<any>
  {    
    const lastNameValue = lastName ?? '';
    const firstNameValue = firstName ?? '';
    const mpiValue = mpi ?? '';
    const dateOfBirthValue = dateOfBirth ?? '';
    return this.http.get(`/pushevent/patient/exists?lastName=${lastNameValue}&firstName=${firstNameValue}&mpi=${mpiValue}&dateOfBirth=${dateOfBirthValue}`);
  }
}
